class ReadMoreContent extends HTMLElement{
  constructor() {
    super();
    this.showMore = this.querySelector('.show-more');
    this.showLess = this.querySelector('.show-less');
    this.content = this.querySelector('.content');
    this.inner = this.querySelector('.content-inner');
    this.theHeight = parseInt(this.dataset.height);
    this.init();
  }
  
  init(){
    if(this.inner.offsetHeight >= this.theHeight){
      this.classList.add('active');
    }
    
    this.showMore.addEventListener('click', ()=>{
      this.setAttribute('opened', true)
      this.content.style.setProperty('max-height', `${this.inner.offsetHeight}px`)
    })
    this.showLess.addEventListener('click', ()=>{
      this.removeAttribute('opened');
      this.content.style.setProperty('max-height', `${this.theHeight}px`)
    })
  }
}
customElements.define('read-more-wrapper', ReadMoreContent);

class ModalDialogs extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
  }
}
customElements.define('modal-dialog-new', ModalDialogs);

class ModalOpeners extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button, .opener');

    if (!button) return;
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener-new', ModalOpeners);

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}